import React, { useEffect, useState } from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap";
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { useGetThesisExamDashboardBasicInfoQuery } from 'src/rtk/features/thesis-exam-dashboard/thesisExamDashboardApi';
import loader from '../../../assets/images/loader.gif';
import ThesisExamScheduleList from './ThesisExamScheduleList';

const ThesisExamDashboard = (props: any) => {
    const { mainDashboard } = props;
    document.title = 'Thesis Exam Dashboard | BCPS';

    const [search, setSearch] = useState('');

    const {
        data: thesisExamDashboardBasicInfoData,
        isSuccess: isThesisExamDashboardBasicInfoDataSuccess,
        isError: isThesisExamDashboardBasicInfoDataError,
        isLoading: isThesisExamDashboardBasicInfoDataLoading,
        error: thesisExamDashboardBasicInfoDataError,
    } = useGetThesisExamDashboardBasicInfoQuery();

    const Counter = ({ end, duration }: any) => {
        const [count, setCount] = useState<number>(0);

        useEffect(() => {
            let start = 0;
            const totalSteps = 60; // Number of updates in the given duration
            const increment = end / totalSteps;

            const stepTime = (duration * 1000) / totalSteps; // Step interval in ms

            const interval = setInterval(() => {
                start += increment;
                if (start >= end) {
                    start = end;
                    clearInterval(interval);
                }
                setCount(Math.floor(start));
            }, stepTime);

            return () => clearInterval(interval);
        }, [end, duration]);

        // Format number with separator
        const formatNumber = (num: number) => num.toLocaleString();

        return (
            <span>
                {formatNumber(count)}
            </span>
        );
    };

    return (
        <>
            {mainDashboard ?
                <React.Fragment>
                    {isThesisExamDashboardBasicInfoDataLoading ? (
                        <div className="overlay">
                            <img src={loader} alt="Loading" height={100} width={300} />
                        </div>
                    ) : null}
                    <BetterBreadcrumb title='Thesis Exam Dashboard' />
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <Card className=''>
                                    <CardBody className='mx-2'>
                                        <h5 className='block-heading mb-2'>Thesis Status</h5>
                                        <div className="row g-3">
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                <div className="dashboard-card h-100 bg-info bg-opacity-10 border border-info text-center p-4 rounded-3">
                                                    <div className="text-info mb-2">
                                                        <i className="fas fa-file-alt fa-2x"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Total Thesis</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={thesisExamDashboardBasicInfoData?.data?.total_thesis ?? 0}
                                                            duration={0.5}
                                                        />
                                                    </h3>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                <div className="dashboard-card h-100 bg-success bg-opacity-10 border border-success text-center p-4 rounded-3">
                                                    <div className="text-success mb-2">
                                                        <i className="fas fa-check-circle fa-2x"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Approved Thesis</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={thesisExamDashboardBasicInfoData?.data?.approved_thesis ?? 0}
                                                            duration={0.5}
                                                        />
                                                    </h3>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                <div className="dashboard-card h-100 bg-secondary bg-opacity-10 border border-secondary text-center p-4 rounded-3">
                                                    <div className="text-secondary mb-2">
                                                        <i className="fas fa-calendar-alt fa-2x"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Upcoming Thesis Exam</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={thesisExamDashboardBasicInfoData?.data?.upcoming_exams ?? 0}
                                                            duration={0.5}
                                                        />
                                                    </h3>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                <div className="dashboard-card h-100 bg-warning bg-opacity-10 border border-warning text-center p-4 rounded-3">
                                                    <div className="text-warning mb-2">
                                                        <i className="fas fa-hourglass-half fa-2x"></i>
                                                    </div>
                                                    <h6 className="text-muted fw-semibold mb-2">Pending Thesis</h6>
                                                    <h3 className="fw-bold mb-0">
                                                        <Counter
                                                            end={thesisExamDashboardBasicInfoData?.data?.pending_thesis ?? 0}
                                                            duration={0.5}
                                                        />
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="12">
                                <Card className=''>
                                    <CardBody>
                                        <h4 className='mb-3'>Thesis Exam Schedule</h4>
                                        <ThesisExamScheduleList />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </React.Fragment>
                :
                <div className='page-content'>
                    {isThesisExamDashboardBasicInfoDataLoading ? (
                        <div className="overlay">
                            <img src={loader} alt="Loading" height={100} width={300} />
                        </div>
                    ) : null}
                    <React.Fragment>
                        <BetterBreadcrumb title='Thesis Exam Dashboard' />
                        <Container fluid>
                            <Row>
                                <Col xl='12'>
                                    <Card className=''>
                                        <CardBody className='mx-2'>
                                            <h5 className='block-heading mb-2'>Thesis Status</h5>
                                            <div className="row g-3">
                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                    <div className="dashboard-card h-100 bg-info bg-opacity-10 border border-info text-center p-4 rounded-3">
                                                        <div className="text-info mb-2">
                                                            <i className="fas fa-file-alt fa-2x"></i>
                                                        </div>
                                                        <h6 className="text-muted fw-semibold mb-2">Total Thesis</h6>
                                                        <h3 className="fw-bold mb-0">
                                                            <Counter
                                                                end={thesisExamDashboardBasicInfoData?.data?.total_thesis ?? 0}
                                                                duration={0.5}
                                                            />
                                                        </h3>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                    <div className="dashboard-card h-100 bg-success bg-opacity-10 border border-success text-center p-4 rounded-3">
                                                        <div className="text-success mb-2">
                                                            <i className="fas fa-check-circle fa-2x"></i>
                                                        </div>
                                                        <h6 className="text-muted fw-semibold mb-2">Approved Thesis</h6>
                                                        <h3 className="fw-bold mb-0">
                                                            <Counter
                                                                end={thesisExamDashboardBasicInfoData?.data?.approved_thesis ?? 0}
                                                                duration={0.5}
                                                            />
                                                        </h3>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                    <div className="dashboard-card h-100 bg-secondary bg-opacity-10 border border-secondary text-center p-4 rounded-3">
                                                        <div className="text-secondary mb-2">
                                                            <i className="fas fa-calendar-alt fa-2x"></i>
                                                        </div>
                                                        <h6 className="text-muted fw-semibold mb-2">Upcoming Thesis Exam</h6>
                                                        <h3 className="fw-bold mb-0">
                                                            <Counter
                                                                end={thesisExamDashboardBasicInfoData?.data?.upcoming_exams ?? 0}
                                                                duration={0.5}
                                                            />
                                                        </h3>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                                                    <div className="dashboard-card h-100 bg-warning bg-opacity-10 border border-warning text-center p-4 rounded-3">
                                                        <div className="text-warning mb-2">
                                                            <i className="fas fa-hourglass-half fa-2x"></i>
                                                        </div>
                                                        <h6 className="text-muted fw-semibold mb-2">Pending Thesis</h6>
                                                        <h3 className="fw-bold mb-0">
                                                            <Counter
                                                                end={thesisExamDashboardBasicInfoData?.data?.pending_thesis ?? 0}
                                                                duration={0.5}
                                                            />
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xl="12">
                                    <Card className=''>
                                        <CardBody>
                                            <h4 className='mb-3'>Thesis Exam Schedule</h4>
                                            <ThesisExamScheduleList />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </React.Fragment>
                </div>
            }
        </>
    );
};

export default ThesisExamDashboard;
